import { render } from "./WordListTrial2.vue?vue&type=template&id=f0c5cb8c&scoped=true"
import script from "./WordListTrial2.vue?vue&type=script&lang=js"
export * from "./WordListTrial2.vue?vue&type=script&lang=js"

import "./WordListTrial2.vue?vue&type=style&index=0&id=f0c5cb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c5cb8c"]])

export default __exports__